import Login from "./Login";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Profile from "./Profile";
import Organization from "./Organization";
import Team from "./Team";
import User from "./User";

export default {
  Login,
  Layout,
  Dashboard,
  Profile,
  Organization,
  Team,
  User
};
